import {
  commissionPeriodToExclusive,
  fetchCommissionReport,
} from "@/hooks/use-commission-report";
import type {
  CommissionEmployeeSummary,
  CommissionEmployeeProject,
  CommissionReport,
} from "@/lib/commission-report-calc";
import type { ReportResolver, ReportRow, Grain, ReportContext } from "@/lib/reports/types";

/**
 * Ren transform — ansatt-grain. Én rad per ansatt med antall prosjekter og
 * total provisjon for perioden. Drillbar ned til per-prosjekt.
 */
export function provisjonRows(byEmployee: CommissionEmployeeSummary[]): ReportRow[] {
  return byEmployee.map((e) => ({
    id: e.user_id,
    label: e.full_name,
    canDrill: true,
    cells: {
      prosjekter: e.project_count,
      provisjon: e.total_provision,
    },
  }));
}

/**
 * Ren transform — prosjekt-grain (drill fra ansatt). Én rad per prosjekt
 * ansatte tjente provisjon på. Ikke videre drillbar.
 */
export function provisjonProsjektRows(detail: CommissionEmployeeProject[]): ReportRow[] {
  return detail.map((d) => ({
    id: d.project_id,
    label: d.project_name,
    canDrill: false,
    cells: {
      provisjon: d.provision,
    },
  }));
}

async function fetchReport(ctx: ReportContext): Promise<CommissionReport> {
  // RPC-en er halvåpen [from, to) — delt konvertering med CSV-eksporten.
  return fetchCommissionReport(commissionPeriodToExclusive(ctx.period));
}

export const provisjonResolver: ReportResolver = {
  async fetch(level: Grain, ctx: ReportContext): Promise<ReportRow[]> {
    const report = await fetchReport(ctx);
    if (level === "ansatt") {
      // INGEN ansatt-filter: provisjon tjenes av SALGSEIERE, som inkluderer
      // ledelse/eiere (Erik, Terje, daglig leder) med monthly_capacity_hours = 0.
      // Et kapasitet>0-filter ville feilaktig droppet dem. Vis alle rader rapporten gir.
      return provisjonRows(report.byEmployee);
    }
    if (level === "prosjekt") {
      const userId = ctx.drillPath[ctx.drillPath.length - 1]?.id;
      return provisjonProsjektRows(report.detailByUser[userId ?? ""] ?? []);
    }
    return [];
  },
};
